import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more: https://cra.link/PWA

serviceWorker.unregister(); // safest default

// Optional: if you want to enable service worker for PWA support (uncomment this)
// serviceWorker.register();

reportWebVitals();
